import React from 'react'
import styled from 'styled-components'

import rightArrow from '../../../static/images/healthtech-page/applications/r-arr.svg'

const ButtonLink = ({type, label, onClick}) => {
    return (
        <ButtonStyle type={type}  onClick={onClick}>
            {label}
            <img src={rightArrow} alt="right-arrow"/>
        </ButtonStyle>
    )
}

export default ButtonLink

const ButtonStyle = styled.button`
  padding: 1rem 2rem 1rem 0rem;
  cursor: pointer;
  margin-top: 2rem;
  background: none;
  border: none;
  color: #3B869D;
  display: flex;
  font-family: Sequel45;
  font-size: 1.6rem;
  align-items: center;
  :hover {
    text-decoration: underline;
  }
  //img {
  //  margin: auto .4rem;
  //}
`
